<template>
  <nav class="navigation">
    <img @click="goBack" src="../assets/icons/back.svg">
    <span>{{ title }}</span>
    <div class="message shadow" :class="{ visible : messageVisible }">
      {{ messageText }}
    </div>
  </nav>
</template>

<style scoped>
.message {
  transition: transform 400ms, opacity 250ms;
  background-color: #77b24b;
  color: white;
  position: fixed;
  top: 65px;
  left: 0px;
  right: 0px;
  padding: 16px;
  pointer-events: none;
  opacity: 0;
  transform: translateY(-25px);
}
.message.visible {
  opacity: 1;
  transform: translateY(0);
}
nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding:20px 15px 15px;
  background-color: var(--fasad-grey-1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 5000;
}
nav span {
  flex: 1;
  text-align: center;
  text-transform: uppercase;
  text-indent: -19px;
}
</style>
<script>
export default {
  name: 'HeaderNavigation',
  computed : {
    messageVisible() {
      return this.$root.messageVisible
    },
    messageText() {
      return this.$root.messageText
    }
  },
  props: {
    title: String
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    }
  }
}
</script>